// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Portal_ClientesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /customer-portal/v1/clientes?documento={canonical}
 *
 * Returns the canonical documento echoed back, the document type (nullable),
 * and an array of cliente records across all franchises sharing that documento.
 *
 * Field names are English per ADR-0014 §3 — everything inside the envelope is
 * English; only the three envelope keys {success, dados, error} stay as they are.
 * The `?documento=` QUERY PARAMETER is deliberately unchanged for now.
 *
 * Shape:
 * - document: string (canonical, echoed back)
 * - document_type: ?object {code, label}
 * - data: array of cliente records, each with client_id, franchise,
 *         name, email, phone, address, created_at, updated_at, active
 */
import type { Portal_Clientes_ClienteRecordRow } from './Portal_Clientes_ClienteRecordRow'
import type { Portal_Clientes_TipoDocumentoRow } from './Portal_Clientes_TipoDocumentoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Portal_ClientesResponseDados {
document: string
data: Portal_Clientes_ClienteRecordRow[]
document_type?: Portal_Clientes_TipoDocumentoRow
}

export type Portal_ClientesResponse = ApiResponse<Portal_ClientesResponseDados>;

registerResponseContract('Portal_ClientesResponse', {
  document: { type: 'string',  required: true },
  data: {
    type: 'array',
    required: true,
    items: {
      client_id:  { type: 'string',  required: true },
      franchise: {
        type: 'object',
        required: true,
        fields: {
          id:    { type: 'string',  required: true },
          name:  { type: 'string',  required: true },
          city:  { type: 'string',  required: false },
          state: { type: 'string',  required: false },
        },
      },
      name:       { type: 'string',  required: true },
      email:      { type: 'string',  required: false },
      phone:      { type: 'string',  required: false },
      address: {
        type: 'object',
        required: false,
        fields: {
          street:      { type: 'string',  required: false },
          number:      { type: 'string',  required: false },
          complement:  { type: 'string',  required: false },
          district:    { type: 'string',  required: false },
          city:        { type: 'string',  required: false },
          state:       { type: 'string',  required: false },
          postal_code: { type: 'string',  required: false },
        },
      },
      created_at: { type: 'string',  required: false },
      updated_at: { type: 'string',  required: false },
      active:     { type: 'boolean', required: true },
    },
  },
  document_type: {
    type: 'object',
    required: false,
    fields: {
      code:  { type: 'string',  required: false },
      label: { type: 'string',  required: false },
    },
  },
})
